import React, {Component} from "react";
import {
    Graphics, Sprite, Text, withPixiApp, Stage, Container, AnimatedSprite
} from "@inlet/react-pixi";
import {connect} from "react-redux";
import {IStore} from "../../../store/IStore";
import {Dispatch} from "redux";
import {actions as reelsActions} from "../../../reducers/reelsStateReducer";
import {actions as asyncActions} from "../../../reducers/asyncServerResponseReducer";
import {actions as winpresentationAction} from "../../../reducers/winPresentationReducer";
import {actions as soundActions} from "../../../reducers/soundReducer";
import {actions as applicationActions} from '../../../reducers/applicationStateReducer'
import {Howl, Howler} from "howler";

import * as PIXI from "pixi.js";
import {Rectangle, Texture} from "pixi.js";

interface IProps {
    [x: string]: any;
}

interface IStateToProps {
}

interface IDispatchToProps {
}

interface IState {


}

export class STARTTEXTCODE extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);


    }


    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {


        return true;
    }


    componentDidMount() {


    }

    render() {
        return (<>
                <Text
                    style={{
                        fontFamily: 'Arial',
                        fontSize: this.props.fontOfText,
                        fontWeight: 'bold',
                        fill: this.props.colofOfText
                    }}
                    x={this.props.xaxis}
                    y={this.props.yaxis}
                    text={this.props.textToDisplay}
                />
            </>

        )
    }
}
